<template>
  <div>
    <vx-card id="" :title="$t('change_password')" class="mb-8">

      <div class="mb-3">
        <vs-input type="password" :label="$t('current_password')" :placeholder="$t('current_password')" v-model="editMyAccountObj.oldPassword" class="w-full"/>
        <validation-error :model-error="accountEditFormErrors.oldPassword"></validation-error>
      </div>

      <div class="mb-3">
        <vs-input type="password" :label="$t('new_password')" :placeholder="$t('new_password')" v-model="editMyAccountObj.password" class="w-full"/>
        <validation-error :model-error="accountEditFormErrors.password"></validation-error>
      </div>

      <div class="mb-3">
        <vs-input type="password" :label="$t('verify_password')" :placeholder="$t('verify_password')" v-model="editMyAccountObj.confirmPassword" class="w-full"/>
        <validation-error :model-error="accountEditFormErrors.confirmPassword"></validation-error>
      </div>

      <template slot="footer">
        <vs-button id="updateMyAccountButton" color="primary" type="filled" @click.prevent="updateMyAccount" v-text="$t('save')"></vs-button>
      </template>

    </vx-card>
  </div>
</template>

<script>
import MyAccount from '@/models/MyAccount'

export default {
  name: 'User.MyAccount.ChangePassword',
  data () {
    return {
      accounts: {},
      editMyAccountObj: {
        user_id: '',
        oldPassword: '',
        password: '',
        confirmPassword: ''
      },
      addMyAccountObj: {},
      clientLevels: {},
      clientGroups: {},
      categories: {},
      imageUrl: '',
      accountEditFormErrors: {}
    }
  },
  mounted () {
    this.loadMyAccountList()
  },
  methods: {
    async loadMyAccountList () {
      const response = await MyAccount.findAll()
      this.accounts = response.data.accounts
      this.editMyAccountObj.user_id = this.accounts.id
      this.imageUrl = `${this.accounts.avatar_url}`
    },
    async updateMyAccount (e) {
      e.preventDefault()
      this.$vs.loading({background: 'primary', color: '#fff', container: '#updateMyAccountButton', scale: 0.45})
      try {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)

          const response = await MyAccount.updatePassword(this.editMyAccountObj)

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.$store.dispatch('setIsFormInProgress', false)

          this.loadMyAccountList()

          this.accountEditFormErrors = {}
          this.editMyAccountObj.oldPassword = ''
          this.editMyAccountObj.password = ''
          this.editMyAccountObj.confirmPassword = ''

        }
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.accountEditFormErrors = errors.validationErrors
        this.$store.dispatch('setIsFormInProgress', false)
      }
      this.$vs.loading.close('#updateMyAccountButton > .con-vs-loading')
    }
  }
}
</script>

<style lang="scss">
  #updateMyAccountButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
